import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import useInlineEditing from '../../hooks/useInlineEditing';

interface Props {
  labelText: string;
  onChange: (text: string) => void;
  height: number;
}

export const EditableLabel: React.FC<Props> = ({
  labelText,
  onChange,
  height,
}) => {
  const {
    isEditing,
    text,
    setText,
    handleOnFocus,
    handleKeyDown,
    handleOnSubmit,
  } = useInlineEditing({ labelText, onChange });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setText(event.target.value);
  };

  if (isEditing) {
    return (
      <InlineInput
        height={height}
        type="text"
        value={text}
        onChange={handleChange}
        onBlur={handleOnSubmit}
        onKeyDown={handleKeyDown}
        placeholder={labelText}
        autoFocus
      />
    );
  }

  return (
    <InlineLabel onClick={handleOnFocus} height={height}>
      {labelText}
    </InlineLabel>
  );
};

const InlineLabel = styled.div<{ height: number }>`
  width: 100%;
  min-height: ${props => props.height}px;

  &:hover {
    border-radius: 1px;
    box-shadow: 0 0 0 2px ${token.blue500};
    background-color: ${token.blue500a10};
  }
`;

// God bless Custom Theming
const InlineInput = styled.input<{ height: number }>`
  width: 100%;
  height: ${props => props.height}px !important;
  border: 0 !important;
  border-radius: 1px !important;
  outline: none !important;
  box-shadow: 0 0 0 2px ${token.blue500} !important;
  font-size: inherit !important;
  font-weight: inherit !important;
  color: inherit !important;
  background-color: inherit !important;
`;
